import { render, staticRenderFns } from "./CustodyAccountInput.vue?vue&type=template&id=01960268&"
import script from "./CustodyAccountInput.vue?vue&type=script&lang=js&"
export * from "./CustodyAccountInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports